<template>
  <div>
    <div v-if="isDisplayColorBtn">
      <div>
        <a
          class="o-tooltip"
          v-on:mouseover="mouseover"
          v-on:mouseleave="mouseleave"
        >
          <button
            type="button"
            class="btn btn-color-circle"
            :style="displayColorStyle"
            @click="onClickColorCircle(hex)"
            >
            <i class="fa icon-check" :class="icon" :id="hex"></i>
          </button>
          <div
            class="o-tooltip-content"
            :class="position"
          >
            <p class="o-tooltip-content-text"><span v-html="msg"></span></p>
          </div>
        </a>
      </div>
    </div>

    <a
      class="o-tooltip"
      v-if="!isDisplayColorBtn"
      v-on:mouseover="mouseover"
      v-on:mouseleave="mouseleave"
    >
      {{ text }}
      <i class="fa" :class="icon"></i>
      <div
        class="o-tooltip-content"
        :class="position"
        :style="{ width: `${msgMaxLength * 10 + 16}px` }"
      >
        <p class="o-tooltip-content-text"><span v-html="msg"></span></p>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  props: ['text', 'icon', 'position', 'msg', 'msgMaxLength', 'isDisplayColorBtn', 'displayColorStyle', 'hex'],
  methods: {
    mouseover: e => {
      e.currentTarget.classList.add('is-show')
    },
    mouseleave: e => {
      e.currentTarget.classList.remove('is-show')
    },
    onClickColorCircle(val) {
      let element = document.getElementById(val)
      element.classList.add('selected')
      this.$emit('close', {'hex': val, 'name': this.msg})
    },
  },
}
</script>

<style lang="scss" scoped>
@keyframes showAnime {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.o-tooltip {
  display: inline-block;
  position: relative;

  &-content {
    z-index: 1;
    position: absolute;
    left: 50%;
    padding: 5px 8px;
    border-radius: 2px;
    background: rgba($BLACK_COLOR, 0.7);
    transform: translate(-50%, 0);
    display: none;

    &:before {
      position: absolute;
      content: '';
    }
  }

  &-content-text {
    position: relative;
    z-index: 2;
    margin: 0;
    color: #fff;
    font-size: 1rem;
    line-height: percentage(18/12);
  }
}

.o-tooltip.is-show {
  .o-tooltip-content {
    display: block;
    animation: showAnime 0.3s ease 0s forwards;
  }
}

.o-tooltip-content.position-bottom {
  bottom: -5px;
  transform: translate(-33%, 100%);

  &:before {
    left: 50%;
    top: 0;
    transform: translate(-50%, -50%);
  }
}

.o-tooltip-content.position-left-top {
  left: -5px;
  top: -5px;
  transform: translate(0%, -100%);

  &:before {
    left: 4px;
    bottom: 0;
    transform: translate(0%, 50%) rotateZ(180deg);
  }
}
.fz-16 {
  font-size: 1.6rem;
}
.position-top {
  padding: 0.5rem 2rem;
  text-align: center;
  top: -2.7rem;
}
.icon-check {
    color: white;
    font-size: 1.5rem;
    text-align: center;
    vertical-align: text-bottom;
    display: none;
}
.selected {
  display: unset;
}
</style>
